const urlBlacklist = [
    "https://files.crazygames.com/"
];

export const isBlacklistUrl = (url: string | null | undefined) : boolean => !!url && urlBlacklist.some(u => url.startsWith(u));